import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {firstValueFrom} from "rxjs";


@Injectable()
export class CsvConverterService {

  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  convertCsvFile(fileId: string): Promise<HttpResponse<string>> {
    let url = `/upload/file/csv/${fileId}/hml`;
    return firstValueFrom(this.http.get(url, {observe: 'response', responseType: 'text'}))
      .catch(this.handleError);
  }

  rejectConvertedCsvFile(fileId: string): Promise<HttpResponse<string>> {
    let url = `/upload/file/reject/${fileId}/hml`;
        return firstValueFrom(this.http.get(url, {observe: 'response', responseType: 'text'}))
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
